"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

exports.__esModule = true;
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _reactUid = require("react-uid");

var _Dictionary = _interopRequireDefault(require("../Dictionary"));

var _Provider = _interopRequireDefault(require("./QueryContext/Provider"));

const OrbitProvider = ({
  theme,
  dictionary,
  children
}) => {
  return /*#__PURE__*/React.createElement(_reactUid.UIDReset, null, /*#__PURE__*/React.createElement(_reactUid.UIDFork, null, /*#__PURE__*/React.createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(_Provider.default, null, dictionary ? /*#__PURE__*/React.createElement(_Dictionary.default, {
    values: dictionary
  }, React.Children.only(children)) : React.Children.only(children)))));
};

var _default = OrbitProvider;
exports.default = _default;